"use client";

import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/components/ui/tooltip";
import { KbdBadge } from "@/components/ui/KbdBadge";

export function ShortcutTooltip({
  label,
  shortcut,
  side = "top",
  children,
}: {
  label: string;
  shortcut: string;
  side?: "top" | "bottom" | "left" | "right";
  children: React.ReactNode;
}) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side}>
        <span className="flex items-center gap-1.5">
          <span>{label}</span>
          <KbdBadge>{shortcut}</KbdBadge>
        </span>
      </TooltipContent>
    </Tooltip>
  );
}
